var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChonghe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 14L4.46039 14",
    stroke: "#00C2FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 0.5625,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33432 4.0625L3.33432 11.1417",
    stroke: "#00C2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41862 9.14361L3.3343 11.0593L5.24999 9.14361",
    stroke: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChonghe);
export default __webpack_public_path__ + "static/media/chonghe.64fabad28a4ab2d5bb31d7dd24d48e07.svg";
export { ForwardRef as ReactComponent };